import React from "react";
import styles from "./Card.module.scss";

const Card = () => {
  return (
    <div className={styles.container}>
      <form>
        <div className={styles.field}>
          <label>Subject / title*</label>
          <input type="email" name="email" placeholder="John.snow@gmail.com" />
        </div>
        <div className={styles.field}>
          <label>Message*</label>
          <textarea
            name="message"
            placeholder="Type your message here.."
          ></textarea>
        </div>
        <button>Submit</button>
      </form>
    </div>
  );
};

export default Card;
